import { inject, Injectable, signal } from '@angular/core';
import { RoutePath } from '../../../../enums/api.enum';
import { Router } from '@angular/router';
import { IAgents, IAgentsResponse, IAgent } from '../../../../interfaces/i-agents';
import { UiLayoutService } from '../../../../ui-layout/services/ui-layout.service';
import { ChatSessionService } from '../../../ai-chat/services/chat-session.service';
import { IInstructions } from '../../interfaces/i-instructions';

@Injectable({
  providedIn: 'root'
})
export class InstructionsService {
  constructor() { }

  instructions = signal<IInstructions[]>([]);
  isEditInstructions = signal<boolean>(false);
}
